import { PayloadAction } from '@reduxjs/toolkit';
import { IFollowList } from '@/store/types';
import { createSliceSteamup } from '../common';

interface IFollowState {
  loading: boolean;
  follow: IFollowList[];
}
const followSlice = createSliceSteamup(
  'follow',
  {
    loading: true,
    follow: [],
  } as IFollowState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.follow)>) {
      state.follow = payload;
    },
    addList(state, { payload }: PayloadAction<(typeof state.follow)>) {
      state.follow.push(...payload);
    },
    remove(state, { payload }: PayloadAction<string>) {
      const idx = state.follow.findIndex(({ uuid }) => uuid === payload);
      state.follow.splice(idx, 1);
    },
  },
);

export default followSlice;
